var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.662 5.234s-.272 3.368-.43 4.786c-.074.678-.493 1.075-1.178 1.087-1.305.024-2.61.025-3.915-.002-.66-.014-1.07-.416-1.144-1.081-.159-1.431-.429-4.79-.429-4.79M10.354 3.62H1.875M8.72 3.62a.824.824 0 0 1-.808-.663L7.79 2.35a.64.64 0 0 0-.618-.475H5.055a.64.64 0 0 0-.618.474l-.122.608a.824.824 0 0 1-.807.663",
    stroke: "#AD0013",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallDelete);
export default __webpack_public_path__ + "static/media/small-delete.8d0fad62306049f91571919c3c38afd6.svg";
export { ForwardRef as ReactComponent };